export default {
	fetchAccount(context) {
		axios.get('/api/v1/account')
             .then( response => {
				let account = response.data.account;
				context.commit('setAccount', account);
		});
	},

	activateTrial(context) {
		context.commit('activateTrial');
	},

	addTimelineToContextualization(context, timeline) {
		context.commit('showContextualizationPanel');
		context.commit('extendContextualizationPanel');
		context.commit('addTimelineToContextualization', timeline);
	},

	removeTimelineFromContextualization(context, timeline) {
		context.commit('removeTimelineFromContextualization', timeline);
	},

	toogleContextualizationPanelStatus(context) {
		context.commit('toogleContextualizationPanelStatus');
	},

	cleanContextualizationTimelines(context) {
		context.commit('cleanContextualizationTimelines');
	},

	showContextualizationPanel(context) {
		context.commit('showContextualizationPanel');
	},

	hideContextualizationPanel(context) {
		context.commit('showContextualizationPanel');
	},

}